// extracted by mini-css-extract-plugin
export const mainView = "projects-module--mainView--3jq5p";
export const image = "projects-module--image--1Md3h";
export const imageText = "projects-module--imageText--3KEXA";
export const imageAndText = "projects-module--imageAndText--3dk_A";
export const box = "projects-module--box--ZnVJq";
export const boxHeading = "projects-module--boxHeading--1JDZT";
export const title = "projects-module--title---50HC";
export const titleFirstLetter = "projects-module--titleFirstLetter--2Bkem";
export const tech = "projects-module--tech--21Zac";
export const techColour = "projects-module--techColour--mqCNY";
export const github = "projects-module--github--2u4YP";